import { render, staticRenderFns } from "./AppContentNewsEdit.vue?vue&type=template&id=982add8a&scoped=true&"
import script from "./AppContentNewsEdit.vue?vue&type=script&lang=js&"
export * from "./AppContentNewsEdit.vue?vue&type=script&lang=js&"
import style0 from "./AppContentNewsEdit.vue?vue&type=style&index=0&id=982add8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982add8a",
  null
  
)

export default component.exports